import { render, staticRenderFns } from "./DocumentsDetailCard.vue?vue&type=template&id=15e25efb&scoped=true"
import script from "./DocumentsDetailCard.vue?vue&type=script&lang=js"
export * from "./DocumentsDetailCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentsDetailCard.vue?vue&type=style&index=0&id=15e25efb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e25efb",
  null
  
)

export default component.exports